import { render, staticRenderFns } from "./advanceDetails.vue?vue&type=template&id=b96e6758&scoped=true&"
import script from "./advanceDetails.vue?vue&type=script&lang=js&"
export * from "./advanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./advanceDetails.vue?vue&type=style&index=0&id=b96e6758&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96e6758",
  null
  
)

export default component.exports